import { Badge } from "@babackapp/customer-ui/components/badge";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { StarFilledIcon } from "@radix-ui/react-icons";
import { RefreshCcw } from "lucide-react";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

export function DiscountOption() {
  const t = useCustomText();
  return (
    <Label htmlFor="discount-type">
      <Option>
        <OptionIcon>
          <RefreshCcw />
        </OptionIcon>
        <OptionTitle>
          {t("discountOption.title")}
          <Badge variant="recomended">
            {t("discountOption.recommended")} <StarFilledIcon />
          </Badge>
        </OptionTitle>
        <OptionDescription>
          {t("discountOption.description")}
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="discount-code" id="discount-type" />
        </OptionAction>
      </Option>
    </Label>
  );
}
